export default __webpack_public_path__ + "static/media/women_ministry.90f01e10.jpg";